export const Icons =[
  'custom-icon-activity',
  'custom-icon-add',
  'custom-icon-agent-location',
  'custom-icon-arrow',
  'custom-icon-arrow-down',
  'custom-icon-arrow-back',
  'custom-icon-arrow-grey',
  'custom-icon-back',
  'custom-icon-bank',
  'custom-icon-call',
  'custom-icon-camera',
  'custom-icon-card',
  'custom-icon-contact-mail',
  'custom-icon-contact-phone',
  'custom-icon-edit',
  'custom-icon-email',
  'custom-icon-error',
  'custom-icon-facebook',
  'custom-icon-finished',
  'custom-icon-gift',
  'custom-icon-google',
  'custom-icon-goto',
  'custom-icon-location',
  'custom-icon-location-pick',
  'custom-icon-myself',
  'custom-icon-new-recipient',
  'custom-icon-order-cancelled',
  'custom-icon-order-expired',
  'custom-icon-order-funding',
  'custom-icon-order-processed',
  'custom-icon-order-ready',
  'custom-icon-progress',
  'custom-icon-recipients',
  'custom-icon-send',
  'custom-icon-settings-biometrics',
  'custom-icon-settings-language-new',
  'custom-icon-settings-help',
  'custom-icon-settings-id',
  'custom-icon-usw-clock',
  'custom-icon-usw-selfie',
  'custom-icon-settings-phone',
  'custom-icon-settings-email',
  'custom-icon-settings-legal',
  'custom-icon-settings-logout',
  'custom-icon-settings-notification',
  'custom-icon-settings-password',
  'custom-icon-settings-passcode',
  'custom-icon-settings-wallet',
  'custom-icon-settings-payment',
  'custom-icon-settings-promotions',
  'custom-icon-settings-personal',
  'custom-icon-settings-question',
  'custom-icon-shield',
  'custom-icon-timeline-circle-active',
  'custom-icon-timeline-circle-inactive',
  'custom-icon-timeline-line-active',
  'custom-icon-timeline-line-inactive',
  'custom-icon-tooltip',
  'custom-icon-track',
  'custom-icon-user',    
  'custom-icon-country-ad',
  'custom-icon-country-ae',
  'custom-icon-country-af',
  'custom-icon-country-ag',
  'custom-icon-country-ai',
  'custom-icon-country-al',
  'custom-icon-country-am',
  'custom-icon-country-ao',
  'custom-icon-country-aq',
  'custom-icon-country-ar',
  'custom-icon-country-as',
  'custom-icon-country-at',
  'custom-icon-country-au',
  'custom-icon-country-aw',
  'custom-icon-country-ax',
  'custom-icon-country-az',
  'custom-icon-country-ba',
  'custom-icon-country-bb',
  'custom-icon-country-bd',
  'custom-icon-country-be',
  'custom-icon-country-bf',
  'custom-icon-country-bg',
  'custom-icon-country-bh',
  'custom-icon-country-bi',
  'custom-icon-country-bj',
  'custom-icon-country-bl',
  'custom-icon-country-bm',
  'custom-icon-country-bn',
  'custom-icon-country-bo',
  'custom-icon-country-bq',
  'custom-icon-country-br',
  'custom-icon-country-bs',
  'custom-icon-country-bt',
  'custom-icon-country-bv',
  'custom-icon-country-bw',
  'custom-icon-country-by',
  'custom-icon-country-bz',
  'custom-icon-country-ca',
  'custom-icon-country-cc',
  'custom-icon-country-cd',
  'custom-icon-country-cf',
  'custom-icon-country-cg',
  'custom-icon-country-ch',
  'custom-icon-country-ci',
  'custom-icon-country-ck',
  'custom-icon-country-cl',
  'custom-icon-country-cm',
  'custom-icon-country-cn',
  'custom-icon-country-co',
  'custom-icon-country-cr',
  'custom-icon-country-cu',
  'custom-icon-country-cv',
  'custom-icon-country-cw',
  'custom-icon-country-cx',
  'custom-icon-country-cy',
  'custom-icon-country-cz',
  'custom-icon-country-de',
  'custom-icon-country-dj',
  'custom-icon-country-dk',
  'custom-icon-country-dm',
  'custom-icon-country-do',
  'custom-icon-country-dz',
  'custom-icon-country-ec',
  'custom-icon-country-ee',
  'custom-icon-country-eg',
  'custom-icon-country-eh',
  'custom-icon-country-er',
  'custom-icon-country-es',
  'custom-icon-country-et',
  'custom-icon-country-fi',
  'custom-icon-country-fj',
  'custom-icon-country-fk',
  'custom-icon-country-fm',
  'custom-icon-country-fo',
  'custom-icon-country-fr',
  'custom-icon-country-ga',
  'custom-icon-country-gb',
  'custom-icon-country-uk',
  'custom-icon-country-gd',
  'custom-icon-country-ge',
  'custom-icon-country-gf',
  'custom-icon-country-gg',
  'custom-icon-country-gh',
  'custom-icon-country-gi',
  'custom-icon-country-gl',
  'custom-icon-country-gm',
  'custom-icon-country-gn',
  'custom-icon-country-gp',
  'custom-icon-country-gq',
  'custom-icon-country-gr',
  'custom-icon-country-gs',
  'custom-icon-country-gt',
  'custom-icon-country-gu',
  'custom-icon-country-gw',
  'custom-icon-country-gy',
  'custom-icon-country-hk',
  'custom-icon-country-hm',
  'custom-icon-country-hn',
  'custom-icon-country-hr',
  'custom-icon-country-ht',
  'custom-icon-country-hu',
  'custom-icon-country-id',
  'custom-icon-country-ie',
  'custom-icon-country-il',
  'custom-icon-country-im',
  'custom-icon-country-in',
  'custom-icon-country-io',
  'custom-icon-country-iq',
  'custom-icon-country-ir',
  'custom-icon-country-is',
  'custom-icon-country-it',
  'custom-icon-country-je',
  'custom-icon-country-jm',
  'custom-icon-country-jo',
  'custom-icon-country-jp',
  'custom-icon-country-ke',
  'custom-icon-country-kg',
  'custom-icon-country-kh',
  'custom-icon-country-ki',
  'custom-icon-country-km',
  'custom-icon-country-kn',
  'custom-icon-country-kp',
  'custom-icon-country-kr',
  'custom-icon-country-kw',
  'custom-icon-country-ky',
  'custom-icon-country-kz',
  'custom-icon-country-la',
  'custom-icon-country-lb',
  'custom-icon-country-lc',
  'custom-icon-country-li',
  'custom-icon-country-lk',
  'custom-icon-country-lr',
  'custom-icon-country-ls',
  'custom-icon-country-lt',
  'custom-icon-country-lu',
  'custom-icon-country-lv',
  'custom-icon-country-ly',
  'custom-icon-country-ma',
  'custom-icon-country-mc',
  'custom-icon-country-md',
  'custom-icon-country-me',
  'custom-icon-country-mf',
  'custom-icon-country-mg',
  'custom-icon-country-mh',
  'custom-icon-country-mk',
  'custom-icon-country-ml',
  'custom-icon-country-mm',
  'custom-icon-country-mn',
  'custom-icon-country-mo',
  'custom-icon-country-mp',
  'custom-icon-country-mq',
  'custom-icon-country-mr',
  'custom-icon-country-ms',
  'custom-icon-country-mt',
  'custom-icon-country-mu',
  'custom-icon-country-mv',
  'custom-icon-country-mw',
  'custom-icon-country-mx',
  'custom-icon-country-my',
  'custom-icon-country-mz',
  'custom-icon-country-na',
  'custom-icon-country-nc',
  'custom-icon-country-ne',
  'custom-icon-country-nf',
  'custom-icon-country-ng',
  'custom-icon-country-ni',
  'custom-icon-country-nl',
  'custom-icon-country-no',
  'custom-icon-country-np',
  'custom-icon-country-nr',
  'custom-icon-country-nu',
  'custom-icon-country-nz',
  'custom-icon-country-om',
  'custom-icon-country-pa',
  'custom-icon-country-pe',
  'custom-icon-country-pf',
  'custom-icon-country-pg',
  'custom-icon-country-ph',
  'custom-icon-country-pk',
  'custom-icon-country-pl',
  'custom-icon-country-pm',
  'custom-icon-country-pn',
  'custom-icon-country-pr',
  'custom-icon-country-ps',
  'custom-icon-country-pt',
  'custom-icon-country-pw',
  'custom-icon-country-py',
  'custom-icon-country-qa',
  'custom-icon-country-re',
  'custom-icon-country-ro',
  'custom-icon-country-rs',
  'custom-icon-country-ru',
  'custom-icon-country-rw',
  'custom-icon-country-sa',
  'custom-icon-country-sb',
  'custom-icon-country-sc',
  'custom-icon-country-sd',
  'custom-icon-country-se',
  'custom-icon-country-sg',
  'custom-icon-country-sh',
  'custom-icon-country-si',
  'custom-icon-country-sj',
  'custom-icon-country-sk',
  'custom-icon-country-sl',
  'custom-icon-country-sm',
  'custom-icon-country-sn',
  'custom-icon-country-so',
  'custom-icon-country-sr',
  'custom-icon-country-ss',
  'custom-icon-country-st',
  'custom-icon-country-sv',
  'custom-icon-country-sx',
  'custom-icon-country-sy',
  'custom-icon-country-sz',
  'custom-icon-country-tc',
  'custom-icon-country-td',
  'custom-icon-country-tf',
  'custom-icon-country-tg',
  'custom-icon-country-th',
  'custom-icon-country-tj',
  'custom-icon-country-tk',
  'custom-icon-country-tl',
  'custom-icon-country-tm',
  'custom-icon-country-tn',
  'custom-icon-country-to',
  'custom-icon-country-tr',
  'custom-icon-country-tt',
  'custom-icon-country-tv',
  'custom-icon-country-tw',
  'custom-icon-country-tz',
  'custom-icon-country-ua',
  'custom-icon-country-ug',
  'custom-icon-country-um',
  'custom-icon-country-us',
  'custom-icon-country-uy',
  'custom-icon-country-uz',
  'custom-icon-country-va',
  'custom-icon-country-vc',
  'custom-icon-country-ve',
  'custom-icon-country-vg',
  'custom-icon-country-vi',
  'custom-icon-country-vn',
  'custom-icon-country-vu',
  'custom-icon-country-wf',
  'custom-icon-country-ws',
  'custom-icon-country-ye',
  'custom-icon-country-yt',
  'custom-icon-country-za',
  'custom-icon-country-zm',
  'custom-icon-country-zw',
  'custom-icon-country-O',
  'custom-icon-tab-send',
  'custom-icon-tab-activity',
  'custom-icon-tab-home',
  'custom-icon-tab-recipients',
  'custom-icon-tab-track',
  'custom-icon-tab-locations',
  'custom-icon-tab-wallet',
  'custom-icon-wallet-deposit',
  'custom-icon-wallet-pay',
  'custom-icon-wallet-withdraw',
  'custom-icon-wallet-pending-status',
  'custom-icon-wallet-success-status',
  'custom-icon-wallet-close-status',
  'custom-icon-tab-hub',
  'custom-icon-wallet-send-request'
];


// WEBPACK FOOTER //
// ./src/model/models/customIcons.ts